/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".three-dots[_ngcontent-%COMP%]{border-radius:10px;font-size:20px;background-color:#fff}.edit-delete-icon[_ngcontent-%COMP%]{margin-right:5px}"];
export { styles as styles };
